import { createClient } from '@supabase/supabase-js'
import { createSupabaseAuthStorage } from './supabaseAuthStorage';
import { getSupabaseAuthStorageKey } from './authStorageKeys';

const supabaseUrl = String(import.meta.env.VITE_SUPABASE_URL || '').trim();
const supabaseAnonKey = String(import.meta.env.VITE_SUPABASE_ANON_KEY || '').trim();
const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  console.error('[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY.');
}

const getSupabaseProjectRef = (url) => {
  try {
    return new URL(url).hostname.split('.')[0];
  } catch (error) {
    return null;
  }
};

const supabaseProjectRef = getSupabaseProjectRef(supabaseUrl);
const supabaseAuthStorageKey = getSupabaseAuthStorageKey(supabaseProjectRef);

export {
  supabaseUrl,
  supabaseAnonKey,
  supabaseProjectRef,
  supabaseAuthStorageKey,
  isSupabaseConfigured,
};

if (typeof window !== 'undefined') {
  window.__AP_SUPABASE_AUTH_STORAGE_KEY__ = supabaseAuthStorageKey;
}

// Global flag to prevent multiple auth state checks
window.__AUTH_CHECK_IN_PROGRESS = false;

// Use placeholders so the bundle can still build before envs are configured.
const supabaseClientUrl = supabaseUrl || 'https://example.supabase.co';
const supabaseClientAnonKey = supabaseAnonKey || 'missing-anon-key';

// Configure client with persistent sessions
export const supabase = createClient(supabaseClientUrl, supabaseClientAnonKey, {
  auth: {
    persistSession: true,
    storage: createSupabaseAuthStorage(),
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: supabaseAuthStorageKey,
  }
})
